import { render } from "./About.vue?vue&type=template&id=c86f6a50"
const script = {}
script.render = render

export default script